import React from 'react'
import {get, flowRight as compose} from 'lodash'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import {withRouter} from 'react-router-dom'
import {graphql} from 'react-apollo'
import Button from '@mui/material/Button'
import {withNamespaces, Trans} from 'react-i18next'
import {Loading} from '../../Common/Loading'
import withStyles from '@mui/styles/withStyles'
import BinaryRoutes from './routes'
import PageTitle from '../../Common/PageTitle'
import PageBody from '../../Common/PageBody'
import messages from '../../../assets/messages'
import {ACCOUNTS_QUERY} from '../../../graphql/queries'
import {isMobile} from '../../../common/utils/browser'
import AppContext from '../../Common/contexts/AppContext'
import TradesmarterDialog from './TradesmarterDialog'
import config from '../../../config'
import {getAccountLabel, getAccountSubtype} from '../../../common/utils/accounts'

const styles = theme => ({
  titleItem: {
    flex: 1,
  }
})

class BinaryAccountView extends React.Component {
  static contextType = AppContext

  state = {
    showTradesmarterDialog: false
  }

  openDialog() {
    this.setState({showTradesmarterDialog: true})
  }

  render() {
    const {loading, account, history, t} = this.props
    const {showTradesmarterDialog} = this.state
    const {featuresConfig:{tradesmarterPopup}} = config
    const {locale, themePreference} = this.context

    if (loading) return <Loading />
    const tabs = [
      {path: '', label: t(messages.overview.i18nKey, messages.overview.defaults)},
      {path: '/transactions', label: t(messages.payments.i18nKey, messages.payments.defaults)},
    ]
    const tabIndex = tabs.findIndex(tab =>
      tab.path.length > 0 && window.location.href.endsWith(tab.path)
    )
    const activeTab = tabIndex >= 0 ? tabIndex : 0

    const label = getAccountLabel(account, locale, getAccountSubtype(get(account,'accountSubtype')), t)

    return (<div>
      {showTradesmarterDialog && tradesmarterPopup && <TradesmarterDialog/>}
      <PageTitle
        themePreference={themePreference}
        title={label}
        onBack={() => history.push('/accounts')}
        withoutPadding={isMobile()}
        rightAction={
          <React.Fragment>
            <Button
              onClick={() => (tradesmarterPopup)?this.openDialog():history.push(`/trade/options/${account.remoteId}`)}
              variant="contained"
              size="large"
              color="primary"
            >
              <Trans {...messages.tradeNow} />
            </Button>
          </React.Fragment>
        }
        subtitle={
          <Trans {...messages.accountID} values={{accountId: account.login}} />
        }
      >
        <Tabs
          variant={isMobile()? 'scrollable' : 'standard'}
          value={activeTab}
          onChange={(_, activeTab) => this.setState({activeTab})}
        >
          {tabs.map((tab, key) =>
            <Tab
              key={key}
              label={tab.label}
              textColor="inherit"
              onClick={() => history.push(`/accounts/${account.id}${tab.path}`)} />
          )}
        </Tabs>
      </PageTitle>
      <PageBody>
        <BinaryRoutes />
      </PageBody>
    </div>)
  }
}

export default compose(
  withNamespaces(),
  withRouter,
  withStyles(styles, {withTheme: true}),
  graphql(ACCOUNTS_QUERY, {
    options: (props) => ({variables: {id: Number(props.match.params.accountId)}}),
    props: ({data: {error, loading}, data}) => ({
      error,
      loading,
      account: get(data, 'viewer.accounts.0'),
    })
  }),
)(BinaryAccountView)
